export const TESTIMONIALS = [
  {
    name: "Giza A.",
    quote: `I had such a wonderful experience! She is very gentle and truly cares about her clients. My skin felt so refreshed, clean, and glowing after the treatment. The relaxing neck and hand massage was such a beautiful touch. Highly recommend!`,
  },
  {
    name: "Katerina E.",
    quote: `Highly recommend Lunar Ambitions! I had a wonderful experience today. My skin feels hydrated, soft, and glowing. The esthetician was caring and made me feel comfortable from start to finish. I left feeling refreshed and absolutely loved the results. I can't wait to come back. ✨💖`,
  },
  {
    name: "Joe D.",
    quote: `Just WOW, I'm so happy with Alena's facial treatment! I've tried cheaper options before and got exactly what I paid for. Alena's service is absolutely worth every penny.`,
  },
];
